/* Charge les enrichissements non critiques du panier uniquement quand le panier devient pertinent. */
(function () {
  var loaded = false;
  var loader = document.currentScript;
  var cssSource = loader && loader.dataset.mpCartCss;
  var sources = loader ? [loader.dataset.mpCartPlus, loader.dataset.mpCartRemove] : [];

  function load() {
    if (loaded) return;
    loaded = true;
    if (cssSource) {
      var stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = cssSource;
      document.head.appendChild(stylesheet);
    }
    sources.filter(Boolean).forEach(function (src) {
      var script = document.createElement('script');
      script.src = src;
      script.async = false;
      document.head.appendChild(script);
    });
  }

  function isCartAction(target) {
    return target && target.closest && target.closest(
      '#cart-icon-bubble, [href="/cart"], [href*="/cart?"], cart-drawer, #CartDrawer, form[action*="/cart"], product-form, .mp-native-bundle, .mp-atc'
    );
  }

  document.addEventListener('pointerdown', function (event) {
    if (isCartAction(event.target)) load();
  }, { passive: true, capture: true });
  document.addEventListener('focusin', function (event) {
    if (isCartAction(event.target)) load();
  }, true);
  document.addEventListener('submit', function (event) {
    if (isCartAction(event.target)) load();
  }, true);
  document.addEventListener('cart:updated', load);
}());
